import { ITestCaseSchema } from '@/api/testCase';
import { CardDetail } from '@/components/shared/card/CardDetail';
import { formatDate } from '@/utils/libs/dateUtil';
import React from 'react';

type TestCaseDetailProps = {
  testCase: ITestCaseSchema;
};

export const TestCaseDetail: React.FC<TestCaseDetailProps> = ({ testCase }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-6">
        <CardDetail title="Type" value={testCase.type_label} />

        <CardDetail title="Module" value={testCase.module?.module_name} />
      </div>

      <div className="flex flex-row gap-6">
        <CardDetail title="Priority" value={testCase.priority_label} />

        <CardDetail title="Tags" value={testCase.tag_label} />
      </div>

      <div className="flex flex-row gap-6">
        <CardDetail
          title="Created By"
          value={testCase?.created_by?.full_name}
        />
        <CardDetail
          title="Created At"
          value={formatDate(testCase.created_at)}
        />
      </div>
      <div className="flex flex-row gap-6">
        <CardDetail
          title="Updated By"
          value={testCase?.updated_by?.full_name}
        />
        <CardDetail
          title="Updated At"
          value={formatDate(testCase.updated_at)}
        />
      </div>
      <div className="flex flex-row gap-6">
        <CardDetail title="Description" value={testCase.description} />

        <CardDetail title="Precondition" value={testCase.precondition} />
      </div>
    </div>
  );
};
